import { ADDRESS_MODEL_CLASS_NAME, ADDRESS_MODEL_KEY } from 'models/daos/address/constants'
import { ARTICLE_MODEL_CLASS_NAME, ARTICLE_MODEL_KEY } from 'models/daos/article/constants'
import { CARD_MODEL_CLASS_NAME, CARD_MODEL_KEY } from 'models/daos/card/constants'
import { CART_PRODUCT_MODEL_CLASS_NAME, CART_PRODUCT_MODEL_KEY } from 'models/daos/cart-product/constants'
import { CART_MODEL_CLASS_NAME, CART_MODEL_KEY_POINTER } from 'models/daos/cart/constants'
import { CATEGORY_MODEL_CLASS_NAME, CATEGORY_MODEL_KEY } from 'models/daos/category/constants'
import { COMMENT_MODEL_CLASS_NAME, COMMENT_MODEL_KEY } from 'models/daos/comment/constants'
import { CURRENCY_MODEL_CLASS_NAME, CURRENCY_MODEL_KEY } from 'models/daos/currency/constants'
import { EMAIL_TEMPLATE_MODEL_CLASS_NAME, EMAIL_TEMPLATE_MODEL_KEY } from 'models/daos/email-template/constants'
import { LOG_MODEL_CLASS_NAME, LOG_MODEL_KEY } from 'models/daos/log/constants'
import { MAILING_LIST_MODEL_CLASS_NAME, MAILING_LIST_MODEL_KEY } from 'models/daos/mailing-list/constants'
import { MOTIVATION_MODEL_CLASS_NAME, MOTIVATION_MODEL_KEY } from 'models/daos/motivation/constants'
import { NOTIFICATION_MODEL_CLASS_NAME, NOTIFICATION_MODEL_KEY } from 'models/daos/notification/constants'
import { ORDER_PRODUCT_MODEL_CLASS_NAME, ORDER_PRODUCT_MODEL_KEY } from 'models/daos/order-product/constants'
import { ORDER_MODEL_CLASS_NAME, ORDER_MODEL_KEY } from 'models/daos/order/constants/index.cjs'
import { PAGE_MODEL_CLASS_NAME, PAGE_MODEL_KEY } from 'models/daos/page/constants'
import { PRODUCT_QUANTITY_MODEL_CLASS_NAME, PRODUCT_QUANTITY_MODEL_KEY } from 'models/daos/product-quantity/constants'
import { PRODUCT_MODEL_CLASS_NAME, PRODUCT_MODEL_KEY } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME, PROMO_CODE_MODEL_KEY } from 'models/daos/promo-code/constants'
import { REPORT_MODEL_CLASS_NAME, REPORT_MODEL_KEY } from 'models/daos/report/constants'
import { SETTINGS_MODEL_CLASS_NAME, SETTINGS_MODEL_KEY } from 'models/daos/settings/constants'
import { SHIPPING_MODEL_CLASS_NAME, SHIPPING_MODEL_KEY } from 'models/daos/shipping/constants'
import { TAG_MODEL_CLASS_NAME, TAG_MODEL_KEY } from 'models/daos/tag/constants'
import { USER_MODEL_CLASS_NAME, USER_MODEL_KEY } from 'models/daos/user/constants'

/**
 * A mapping of className to attribute map.
 * @type {Object}
 */
const MODEL_KEY = {
  [ADDRESS_MODEL_CLASS_NAME]: ADDRESS_MODEL_KEY,
  [ARTICLE_MODEL_CLASS_NAME]: ARTICLE_MODEL_KEY,
  [CATEGORY_MODEL_CLASS_NAME]: CATEGORY_MODEL_KEY,
  [CARD_MODEL_CLASS_NAME]: CARD_MODEL_KEY,
  [CART_MODEL_CLASS_NAME]: CART_MODEL_KEY_POINTER,
  [CART_PRODUCT_MODEL_CLASS_NAME]: CART_PRODUCT_MODEL_KEY,
  [COMMENT_MODEL_CLASS_NAME]: COMMENT_MODEL_KEY,
  [CURRENCY_MODEL_CLASS_NAME]: CURRENCY_MODEL_KEY,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: EMAIL_TEMPLATE_MODEL_KEY,
  [LOG_MODEL_CLASS_NAME]: LOG_MODEL_KEY,
  [MAILING_LIST_MODEL_CLASS_NAME]: MAILING_LIST_MODEL_KEY,
  [MOTIVATION_MODEL_CLASS_NAME]: MOTIVATION_MODEL_KEY,
  [NOTIFICATION_MODEL_CLASS_NAME]: NOTIFICATION_MODEL_KEY,
  [ORDER_MODEL_CLASS_NAME]: ORDER_MODEL_KEY,
  [ORDER_PRODUCT_MODEL_CLASS_NAME]: ORDER_PRODUCT_MODEL_KEY,
  [PAGE_MODEL_CLASS_NAME]: PAGE_MODEL_KEY,
  [PROMO_CODE_MODEL_CLASS_NAME]: PROMO_CODE_MODEL_KEY,
  [PRODUCT_MODEL_CLASS_NAME]: PRODUCT_MODEL_KEY,
  [PRODUCT_QUANTITY_MODEL_CLASS_NAME]: PRODUCT_QUANTITY_MODEL_KEY,
  [REPORT_MODEL_CLASS_NAME]: REPORT_MODEL_KEY,
  [SETTINGS_MODEL_CLASS_NAME]: SETTINGS_MODEL_KEY,
  [SHIPPING_MODEL_CLASS_NAME]: SHIPPING_MODEL_KEY,
  [TAG_MODEL_CLASS_NAME]: TAG_MODEL_KEY,
  [USER_MODEL_CLASS_NAME]: USER_MODEL_KEY
}

/**
 * Checks whether the given key is in the schema.
 * @param  {string}  className
 * @param  {string}  key
 * @returns {boolean}
 */
function isKeyInSchemaModelUtil (className, key) {
  return !!Object.values(
    MODEL_KEY[className]
  ).includes(key)
}

export {
  isKeyInSchemaModelUtil
}
